import 'App.css';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Routes, Route } from "react-router-dom";
import { fetchCompanyDetails, getCompanyDetails } from './APILayer/CommonAPIs/ApiCodGetCompanyDetails';
import DismissAction from './CommonComponents/DismissAction';
import Config from './Pages/Config';
import Login from './Pages/Login';
import {
  dashRoutesUserManuAdmin,
  dashRoutesUserManu,
} from "routes.js";
import {
  getApplicationConfig,
  getdashboardConfig,
  getEnabledRoutes,
  getIsLoggedIn,
  setAllIncidents,
  setAnalyticSummaryPageData,
  setApplicationConfig,
  setDashboardConfig,
  setEnabledRoutes,
} from './Redux/DashboardVariables';
import store from './storage';
import { callRuntimeEvents } from 'APILayer/ManuDashboardAPIs/ApiGetRuntimeEvents';
import SidebarLeft from 'Layout/SidebarLeft';
import DoriSnackbar from 'CommonComponents/DoriSnackbar';
import { IncidentTypesGE } from 'HelperFiles/Constants';
import { IncidentTypesManufacturing } from 'HelperFiles/Constants';
import { generateAnalyticSummaryPageData } from 'HelperFiles/DataGenerator';
import { IncidentTypesAHF } from 'HelperFiles/Constants';
import { showSnackbar } from 'Redux/ShowSnackbar';
import { IncidentTypesDMS } from 'HelperFiles/Constants';
import { IncidentTypesDomtar } from 'HelperFiles/Constants';

const App = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(getIsLoggedIn);
  const companies = useSelector(getCompanyDetails);
  const dashboardConfig = useSelector(getdashboardConfig);
  const applicationConfig = useSelector(getApplicationConfig);
  const enabledRoutes = useSelector(getEnabledRoutes);

  useEffect(() => {
    if (enabledRoutes.length != 0) {
      if (dashboardConfig === "COD") {
        navigate("/app/dashboard");
        dispatch(callRuntimeEvents({}))
        console.log("Routes set for admin");
      } else {
        console.log("Invalid dashboard configuration");
        navigate("/config");
      }
      console.log("Routes set for application");
    } else {
      console.log("No routes set");
    }
  }, [enabledRoutes]);

  useEffect(() => {
    console.log('app config set: ', applicationConfig);
    if (applicationConfig.includes('DashboardManufacturingBundle')) {
      dispatch(setEnabledRoutes(dashRoutesUserManuAdmin));
    }
  }, [applicationConfig])

  useEffect(() => {
    console.log('dashboard config: ', dashboardConfig, companies);
    if (dashboardConfig && companies.length) {
      dispatch(setApplicationConfig(companies[0].name));
      if (companies[0].name === "DashboardManufacturingBundleGEAppliances") {
        dispatch(setAllIncidents(IncidentTypesGE));
        dispatch(setAnalyticSummaryPageData(generateAnalyticSummaryPageData({
          applicationConfig: companies[0].name,
          allIncidents: IncidentTypesGE
        })));
      } else if (companies[0].name === "DashboardManufacturingBundleAHF") {
        dispatch(setAllIncidents(IncidentTypesAHF));
        dispatch(setAnalyticSummaryPageData(generateAnalyticSummaryPageData({
          applicationConfig: companies[0].name,
          allIncidents: IncidentTypesAHF
        })));
      } else if (companies[0].name === "DashboardManufacturingBundleDMS-Safety") {
        dispatch(setAllIncidents(IncidentTypesDMS));
        dispatch(setAnalyticSummaryPageData(generateAnalyticSummaryPageData({
          applicationConfig: 'DashboardManufacturingBundleDMS-Safety',
          allIncidents: IncidentTypesDMS
        })));
      } else if (companies[0].name === "DashboardManufacturingBundleDomtar-Gantry") {
        dispatch(setAllIncidents(IncidentTypesDomtar));
        dispatch(setAnalyticSummaryPageData(generateAnalyticSummaryPageData({
          applicationConfig: 'DashboardManufacturingBundleDomtar-Gantry',
          allIncidents: IncidentTypesDomtar
        })));
      } else {
        dispatch(setAllIncidents(IncidentTypesManufacturing));
        dispatch(setAnalyticSummaryPageData(generateAnalyticSummaryPageData({
          applicationConfig: companies[0].name,
          allIncidents: IncidentTypesManufacturing
        })));
      }
    }
  }, [dashboardConfig]);

  useEffect(() => {
    if (companies && companies.length > 0) {
      if (
        !dashboardConfig ||
        dashboardConfig === null ||
        dashboardConfig === ""
      ) {
        console.log("Setting up dashboard configuration");
        let user = store.get("user");

        if (user && user.userRole === "DORI_ADMIN") {
          dispatch(setDashboardConfig("ICD"));
        } else if (user && user.userRole === "USER_ADMIN") {
          dispatch(setDashboardConfig("COD"));
        } else if (user && user.userRole === "USER") {
          dispatch(setDashboardConfig("COD"));
        } else {
          console.log("Unknown user role found");
        }
      } else {
        console.log("Current dashboard configuration:", dashboardConfig);
      }

    }
  }, [companies]);

  useEffect(() => {
    let loggedIn = isLoginValid();
    console.log("Checking for valid login: ", loggedIn, companies, process.env.REACT_APP_DORI_APP_SERVER);
    if (process.env.REACT_APP_DORI_APP_SERVER && !loggedIn) {
      navigate("/login");
    } else if (process.env.REACT_APP_DORI_APP_SERVER && loggedIn) {
      if (!companies || companies.length == 0) {
        dispatch(fetchCompanyDetails());
      }
    }
    else {
      if (loggedIn) {
        if (!companies || companies.length == 0) {
          dispatch(fetchCompanyDetails());
        }
      } else {
        console.log("Valid login not found");
        navigate("/login");
      }
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (process.env.REACT_APP_DORI_APP_SERVER) {
      localStorage.setItem('shouldUseSessionStorage', false);
    } else {
      localStorage.setItem('shouldUseSessionStorage', true);
    }
  }, [])

  const isLoginValid = () => {
    let currTime = new Date().getTime();
    let user = store.get("user");
    if (!user) {
      console.log("No user. Signing out");
      return false;
    }
    let sessionExpiry = user && user.sessionExpiry ? user.sessionExpiry : 0;
    if (sessionExpiry !== 0 && currTime > sessionExpiry) {
      dispatch(showSnackbar({
        message: "Session Expired. Please log in again.",
        severity: 'error',
      }));
      console.log("Session expiry. Signing out");
      return false;
    };
    const authToken = store.get("authToken");
    if (!authToken || authToken === "") {
      dispatch(showSnackbar({
        message: "You have been logged out. Please login again.",
        severity: 'error',
      }));
      console.log("No authToken. Signing out");
      return false;
    };
    return true;
  }

  const getRoutes = () => {
    return enabledRoutes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/app") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            Component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  // console.log('Application main log: ',
  //   isLoggedIn,
  //   companies,
  //   dashboardConfig,
  //   applicationConfig,
  //   enabledRoutes
  // );

  return (
    <div className='App'>
      <DoriSnackbar />
      {(window.location.href.includes('/app')) &&
        <div className='sidebarContainer'>
          <SidebarLeft />
        </div>
      }

      <div className='loginPageContainer'>
        <Routes>
          {/* <Route exact path="/signout" Component={Login} /> */}
          <Route exact path="/login" Component={Login} />
        </Routes>
      </div>

      <div className='dashboardContainer'>
        <Routes>
          <Route exact path="/" element={<Config />} />
          {getRoutes()}
        </Routes>
      </div>
    </div>
  );
}

export default App;
